import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'hideMarkers'})
export class HideMarkers implements PipeTransform {
  transform(value:string):string {
    return value.replace(/([\[](.*?)[\]])+/ig,'');
  }
}
